import React from 'react';
import { useIntl } from 'react-intl';
import {toAbsoluteUrl} from '../../../../../_dashboard/helpers'

interface ImageUploaderProps {
  image: { url: string; _id: string } | null; 
  handleImageClick: () => void; 
}

const ImageUploader: React.FC<ImageUploaderProps> = ({ image, handleImageClick }) => {
  const intl = useIntl();

  return (
    <div className='image-container-dashed'>
          <div className='image-container-placeholder' onClick={() => handleImageClick()}>
            <img src={toAbsoluteUrl('/media/icons/upload-image.png')} alt="uploadimage" />
            <span>{intl.formatMessage({ id: 'COMMON.ADD' })}</span>
          </div>
    </div>
  );
};

export default ImageUploader;